<!-- webView -->
<div class="container-fluid webView" style="padding: 0px 5px;">
    <div class="col-md-12 col-12 col-sm-12" style="display: flex; align-items: center; padding: 15px 0px;">
        <div class="col-md-6 col-sm-6">
            <h2 class="header lblHeader newHeader">
                Stock Batches
            </h2>
        </div>
        <div class="col-md-6 col-sm-6" style="text-align: right;">
            <span class="">
                <span class="fa fa-search" style="padding-left: 13px; font-size: 14px;
                position: absolute;top: 8px;color: #999;"></span>
                <input class="form-control formCtlFltr brdrRadius3" placeholder="Search" matInput (keyup)="searchFilter($event)"  style="text-align: left; background-color: white; display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 45% !important; height: 31px !important;" type="text">   
            </span>

            <span (click)="exportToExcelActivities()" class="orangeButton" style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
                <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
            </span>

            <span (click)="refresh()" class="darkBlueButton" style="margin-left: 10px; cursor: pointer;" title="Refresh">
                <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
            </span>
  
            <div style="display: inline-block; padding: 0px;" title="Return to Inventory">
                <span class="darkBlueButton" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-12 col-sm-12">
        <div style="display: flex; width: 100%; align-items: center; gap: 10px; " >
            <!-- Categories -->
            <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.categoryID" (change)="applyFilter('category')">
                <option [ngValue]="0">All Categories</option>
                <option *ngFor="let c of categories" [ngValue]="c.cid">{{c.cnm}}</option>
            </select>
    
            <!-- Sub-Categories -->
            <select disabled="{{subCategories.length == 0}}" class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.subCategoryID" (change)="applyFilter('subcategory')">
              <option [ngValue]="0">All Sub-Categories</option>
              <option *ngFor="let sc of subCategories" [ngValue]="sc.sid">{{sc.snm}}</option>
            </select>
    
            <!-- Importace -->
            <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.importanceID" (change)="applyFilter('imp')">
              <option [ngValue]="3">All Importance Levels</option>
              <option [ngValue]="0">Low</option>
              <option [ngValue]="2">Normal</option>
              <option [ngValue]="1">High</option>
            </select>

            <!-- Expiry -->
            <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.expiryStatus" (change)="applyFilter('expiry')">
                <option [ngValue]="0">All Expiry Levels</option>
                <option [ngValue]="1">Expired</option>
                <option [ngValue]="2">Not Expired</option>
            </select>
                        
            <div *ngIf="selectedFilter.expiryStatus == 2" style="margin-left: 8px;">
                <div style="position: relative;">
                    <span style="font-size: 13px; margin-left: -11PX;color: #555;">Expiring on/before : </span>
                    <input type="text"tabindex="1" [(ngModel)]="selectedDate" (ngModelChange)="applyFilter('expiry')"class="form-control formCtlFltr"[matDatepicker]="picker"[min]="minDate" readonly [placeholder]="'Select Date'" (click)="picker.open()" style="background-color: white; padding: 6px; width: 80px; margin-left: 1px;"/>
                    <mat-datepicker-toggle matSuffix [for]="picker" style="position: absolute; top: 50%; transform: translateY(-50%);"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </div>
            </div>
              
                         
        </div>
    </div>
    <!-- Table -->    
    <div class="wrapper" style="overflow: auto; padding-left: 0px !important; text-overflow: ellipsis; white-space: nowrap; padding-top: 5px; padding-right: 14px;border-radius: 3px;" *ngIf="dataSource.data.length > 0">
      <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
        <ng-container matColumnDef="ItemName">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px;">Item</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.ItemName}} </td>
        </ng-container>

        <ng-container matColumnDef="ItemCode">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px; padding-left: 8px;">Code</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.ItemCode}} </td>
        </ng-container>

        <ng-container matColumnDef="BatchName">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px; padding-left: 8px;">Batch</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.BatchName}} </td>
        </ng-container>

        <ng-container matColumnDef="BatchQty">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header arrowPosition="before" style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px; padding-right: 8px;">Qty</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: right;"> {{item.BatchQty}} </td>
        </ng-container>

        <ng-container matColumnDef="SKU">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px; padding-left: 8px;">Unit</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.SKU}} </td>
        </ng-container>

        <ng-container matColumnDef="EntryDT">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px; padding-left: 8px;">Entry</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.EntryDT | todayTommorow}} </td>
        </ng-container>

        <ng-container matColumnDef="ExpiryDT">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
                <label style="font-size: 13px; padding-left: 8px;">Expiry</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.BatchType == 2  ? (item.ExpiryDT | todayTommorow) : '-'}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
     
     <mat-paginator
          [pageSizeOptions]="[10, 15]" showFirstLastButtons>
     </mat-paginator>
  </div>
  <div *ngIf="dataSource.data.length == 0">
    <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
  </div>
</div>

<!-- mobView -->
<div class="container-fluid padMob bg mobView bggray" style="padding-right: 0px; margin-bottom: 15px;">
    <div class="row">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding-bottom: 0px;">
            <div class="col-md-6 col-6 col-sm-6 pad0 inLneBlk">
            <h4 style="font-size: 30px;" class="newHeader">Stock Batches</h4>
            </div>
            <div class="col-md-6 col-6 col-sm-6 pad0 inLneBlk" style="vertical-align: top;">
            <span class="btn darkBlueButton" style="float: right; position: relative; padding: 2px 9px;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 5px;"></i>Back
            </span>
            <span (click)="refresh()" class="darkBlueButton" style="margin-right: 8px; float: right; cursor: pointer;" title="Refresh">
                <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
            </span>
            <span class="orangeButton mobileView" style="margin-right: 8px !important; float: right; font-size: 14px; cursor: pointer; position: relative;" (click)="exportToExcelActivities()">
                <i class="fa fa-file-excel-o"></i>
            </span>
            </div>
        </div>
    
        <!-- Search -->
        <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 10px 15px 0px 15px;">
            <div class="input-icons search">
                <span class="fa fa-search" style="top: 17px !important; color: #BCC2C9 !important;"></span>
                <input class="form-control formCtlFltr brdrRadius3" placeholder="Search" matInput [(ngModel)]="search" (keyup)="searchFilter($event)"
                    style="padding-left: 35px !important; box-shadow: none;border: 1px solid #BCC2C9 !important; width: 100%; float: left;" type="text">
            </div>
        </div>

        <!-- Filters -->
        <div style="width: 100%; margin-top: 10px; padding-left: 15px; padding-right: 15px;">
            <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
            <!-- Category Filter -->
            <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selectedFilter.categoryID" tabindex="1" (change)="applyFilter('category')">
                <option [value]="0">All Categories</option>
                <option *ngFor="let c of categories" [value]="c.cid">{{c.cnm}}</option>
            </select>
            <!-- Sub-Category Filter -->
            <select [disabled]="subCategories.length == 0" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selectedFilter.subCategoryID" tabindex="1" (change)="applyFilter('subcategory')">
                <option [value]="0">All Sub-Categories</option>
                <option *ngFor="let sc of subCategories" [value]="sc.sid">{{sc.snm}}</option>
            </select>
        </div>
  
        <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
          <!-- Importance Filter -->
            <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 52%; max-width: 180px;" [(ngModel)]="selectedFilter.importanceID" (change)="applyFilter('imp')">
                <option value="3">All Importance Levels</option>
                <option value="0">Low</option>
                <option value="2">Normal</option>
                <option value="1">High</option>
            </select>
          <!--Expiry Filter-->
            <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.expiryStatus" (change)="applyFilter('expiry')" style="width: 52%;">
            <option [ngValue]="0">All Expiry Levels</option>
            <option [ngValue]="1">Expired</option>
            <option [ngValue]="2">Not Expired</option>
            </select>
        </div>
    
        <div *ngIf="selectedFilter.expiryStatus == 2" style="display: flex; align-items: center; margin-left: 4px; gap: 2px;">
            <span style="font-size: 13px; color: #555; white-space: nowrap;"> Expiring on/before : </span>
            <div style="position: relative; display: flex; align-items: center; gap: 5px;">
                <input type="text" tabindex="1" [(ngModel)]="selectedDate" (ngModelChange)="applyFilter('expiry')" class="form-control formCtlFltr" [matDatepicker]="picker" [min]="minDate" readonly [placeholder]="'Select Date'" (click)="picker.open()" style="background-color: white; padding: 6px; width: 80px; margin-left: 3px;"/>
                <mat-datepicker-toggle matSuffix [for]="picker" style="cursor: pointer; margin-left: -8px; align-items: center;"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </div>
        </div>

    <!-- Table -->
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12 col-sm-12 col-xs-12" id="mobList"style="padding: 0">
        <div *ngIf="dataSource.data.length == 0" style="margin: 10px 15px; color: #555;">
          <span class="font12">No records found.</span>
        </div>
        <!-- List box -->
        <div *ngFor="let item of dataSource.data | filter: 'ItemName': search" style="margin-top: 10px; border: 1px solid #ddd; border-radius: 3px; padding: 10px; width: 100%; background:white;">
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <div style="font-size: 16px;">
                    {{item.ItemName}}
                </div>
                <div style="font-size: 14px;">
                    <b>{{item.BatchQty}} {{item.SKU}}</b>
                </div>
            </div>
            <div style="display: flex; align-items: center; column-gap: 4px; flex-wrap: wrap;">
                <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
                    Code <b>{{item.ItemCode}}</b>
                </div>
                <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
                    Batch <b>{{item.BatchName}}</b>
                </div>
                <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
                    Entry <b>{{item.EntryDT | todayTommorow}}</b>
                </div>
                <div *ngIf="item.BatchType == 2" class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
                    Expiry <b>{{item.ExpiryDT | todayTommorow}}</b>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>
